import { Alert, SxProps } from "@mui/material"
import { PropsWithChildren } from "react"

interface LoadingErrorProps {
  id?: string;
  sx?: SxProps;
}

export const LoadingError = ({
    children, id, sx
}: PropsWithChildren<LoadingErrorProps>) => {
  return (
    <Alert id={id} severity='error' sx={sx}>{children}</Alert>
  )
}
